import { useNavigate } from "react-router-dom";
import RolesListTopbar from "../../features/manageSubAdmin/rolesTopbar";
import RolesList from "../../features/manageSubAdmin/rolesList";
import { useState } from "react";

const ManageSubadminRoles = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouceSearchTerm, setDebouceSearchTerm] = useState<string>("");

  return (
    <>
      <div className="main_title">
        <h1>Manage Roles</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-subadmin")}>
            Manage Sub-Admin
          </button>{" "}
          - Manage Roles
        </p>
      </div>

      <div className="cards">
        <RolesListTopbar
          setDebouceSearchTerm={setDebouceSearchTerm}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
        <RolesList search={debouceSearchTerm} />
      </div>
    </>
  );
};

export default ManageSubadminRoles;
